import React from "react";
import T from "prop-types";
import { Map } from "immutable";

import LocationFlag from "MODULES/shared/components/LocationFlag";
import { isEmpty } from "lodash";

const locationFlagCount = (locationId, quantities) => [
  isEmpty(locationId) ? "N/A" : <LocationFlag location={locationId} />,
  <span>{quantities.get(locationId) || 0} </span>
];

const locationFlags = quantities =>
  Object.keys(quantities.toJS()).map(locationId =>
    locationFlagCount(locationId, quantities)
  );

export default function SellableQty({ quantities, style = {} }) {
  if (quantities.size === 0) return null;

  return (
    <span className="pull-right" style={style}>
      Sellable Quantity: {locationFlags(quantities)}
    </span>
  );
}

SellableQty.propTypes = {
  quantities: T.instanceOf(Map),
  style: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/shared/SellableQty.jsx